import { ComponentProps } from 'react';

import { cn } from 'src/lib/utils';

import { DialogFooter } from 'src/components/ui/dialog';

export default function CustomModalFooter({
  className,
  ...props
}: ComponentProps<'div'>) {
  return <DialogFooter className={cn('tw:p-4', className)} {...props} />;
}
